import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-901ef122"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tether-result" }
const _hoisted_2 = { class: "tether-result__item" }
const _hoisted_3 = { class: "font-english" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "35"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#0668E1",
    d: "M31.758 28.435h-6.493l-8.826-10.936 8.826-10.936h6.493l-8.826 10.936 8.826 10.936zm-7.781 6.015H13.913L.232 17.499 13.913.547h10.064L10.296 17.499 23.977 34.45z"
  })
], -1))
const _hoisted_5 = { class: "tether-result__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(parseInt(_ctx.tether).toLocaleString()), 1),
      _createTextVNode(" تتر ")
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, _toDisplayString(parseInt(_ctx.toman).toLocaleString()) + " تومان ", 1)
  ]))
}